import Navbar from '../components/Navbar';
import Landing from '../components/Landing';
import Footer from '../components/Footer';
function Home(){
    return (
        <>

        <Navbar/>
        <Landing/>
        <Footer/> 
        
        </>
    )
}

export default Home;